module.exports = __webpack_public_path__ + "img/pi3ckleftsection.753e4ab9.png";